import { Icon } from '@components/Icon/Icon';
import { css } from '@emotion/react';
import type { IconName } from '@components/Icon/BaseIcon';
import type { NotificationKind } from './helpers';
import { color } from '@tokens';

export const ICONS: { [key: string]: IconName } = {
  info: 'info',
  danger: 'warning',
  success: 'check',
  warning: 'warning',
  upsell: 'info',
};

/**
 * NotificationIcon component.
 *
 * **WARNING!** _This component is for internal use in the Design System. If you
 * need to use it for a custom component, please discuss your use case with
 * the Design System squad before proceeding, as they may be able to help
 * you with a better solution._
 * @summary Provides an icon for notification components.
 * @private
 */
export const NotificationIcon = ({
  kind,
  className,
}: {
  kind: NotificationKind;
  className?: string;
}): JSX.Element => {
  return (
    <Icon
      icon={ICONS[kind]}
      size="m"
      className={className}
      css={css`
        flex-shrink: 0;
        fill: ${color.text_default};
      `}
    />
  );
};
